<br>
<br>
<br>
<br>
<br>
<br>
<br>
<br>
<p>
  FormProductoReactivo works!
</p>
<div class="container bg-light">
  <div class="row"> 
    <div class="col-md-12">
      <form class="p-3" [formGroup]="miFormulario" autocomplete="off" (ngSubmit)="guardar()">
        <div class="form-group">
          <label for="">Producto</label>
          <input class="form-control" type="text" formControlName="producto">
          <small class="form-text text-danger"
                 *ngIf="campoEsValido('producto')">Debe ingresar el Producto</small>
        </div>
        <div class="form-group">
          <label for="">Precio</label>
          <input class="form-control" type="number" formControlName="precio">
          <small class="form-text text-danger"
                  *ngIf="campoEsValido('precio')">Debe ingresar el Precio</small>
        </div>
        <div class="form-group">
          <label for="">Existencias</label>
          <input class="form-control" type="number" formControlName="existencia">
          <small class="form-text text-danger"
                 *ngIf="campoEsValido('existencia')">Debe ingresar la Existencia</small>
        </div>
        <button type="submit"
                class="btn btn-primary"
                [disabled]="miFormulario.invalid">Grabar</button>
      </form>
    </div>
    <div class="col-md-12">
      <span>Valid</span>
      <pre>{{miFormulario.valid | json}}</pre>
      
      <span>Pristine</span>
      <pre>{{miFormulario.pristine | json}}</pre>

      <span>Touched</span>
      <pre>{{miFormulario.touched | json}}</pre>

      <span>Value</span>
      <pre>{{miFormulario.value | json}}</pre>

    </div>
  </div>
</div>